import { Icon, Popup } from 'semantic-ui-react';

export default function genPopup({ message = 'Loading...', _className = 'p3' }) {
  return (
    <Popup mouseLeaveDelay={500} hoverable trigger={<Icon name="question circle" />} wide>
      {message}
    </Popup>
  );
}
